// working maintenance

import React, { useEffect, useRef, useState } from "react";
import Top from "../Top";
import Leftsiderbar from "../home/allcmp/Leftsidebar";
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles(() => ({
  customTooltip: {
    backgroundColor: "black",
    fontSize: "15px",
  },
}));
const Devices = () => {
  const navigate = useNavigate();
  let uid = localStorage.getItem("user_id");
  let user_type = localStorage.getItem("user_type");

  useEffect(() => {
    if (user_type === "6") {
      navigate("/distributor-dashboard");
    }
  }, [user_type, navigate]);

  const classes = useStyles();
  const handleDevice6 = () => {
    if (user_type == "7") {
      navigate("/six/devices?dist=" + uid);
    } else {
      navigate("/six/devices");
    }
  };
  const handleGoDevice = () => {
    if (user_type == "7") {
      navigate("/seven/devices?dist=" + uid);
    } else {
      navigate("/seven/devices");
    }
  };
  const handleCapnoGoDevice = () => {
    if (user_type == "7") {
      navigate("/capno-go/devices?dist=" + uid);
    } else {
      navigate("/capno-go/devices");
    }
  };
  const handleDevice5 = () => {
    if (user_type == "7") {
      navigate("/five/devices?dist=" + uid);
    } else {
      navigate("/five/devices");
    }
  };

  return (
    <div className="">
      <div className="cmail">
        <Top />
      </div>
      <div className="wrp-dashbord">
        <div className="cemail-left">
          <Leftsiderbar />
        </div>
        <div className="right-section">
          <div className="add-btn-wrp add-btn-wrp2">
            <div className="button-div">
              <button className="create-button" onClick={handleCapnoGoDevice}>
                Device Capno GO{" "} <span style={{fontSize:"14px",marginLeft:"5px",color: "orange"}}>(Under development)</span>
              </button>
              <button className="create-button" onClick={handleGoDevice}>
                Device GO
              </button>
              <button className="create-button" onClick={handleDevice6}>
                Device 6.0
              </button>
              <button className="create-button" onClick={handleDevice5}>
                Device 5.0
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Devices;
